console.log('[FE] V 1.1.5');
import { Constants } from './v2-fgen-constants.js';
import { FE$BaseFunctionExecutor, FE$XInterpreter } from './v2-fgen-fexinterpreter.js';

Object.values = Object.values || function (o) { return Object.keys(o).map(function (k) { return o[k] }) };

var fe$utils = (function () {
   var ret = {}
   const urlParams = new URLSearchParams(window.location.search)
   ret.clearChildren = function (el) {
      while (el.hasChildNodes()) {
         el.removeChild(el.firstChild);
      }
   }
   ret.isDictEmpty = function (dict) {
      for (var i in dict) {
         if (dict.hasOwnProperty(i)) {
            return false;
         }
      }
      return true;
   }
   ret._hasClass = function (cls, classes) {
      var aClasses = classes.split(' ');
      for (var i = 0; i < aClasses.length; i++) {
         if (aClasses[i] === cls) {
            return true;
         }
      }
      return false;
   }
   ret.hasClass = function (cls, element) {
      var classes = element.getAttribute('class');
      if (!classes) {
         classes = '';
      }
      return this._hasClass(cls, classes);
   }
   ret.addClass = function (cls, element) {
      var classes = element.getAttribute('class');
      if (!classes) {
         classes = '';
      }
      if (!this._hasClass(cls, classes)) {
         element.setAttribute('class', classes + ' ' + cls);
      }
   }
   ret.removeClass = function (cls, element) {
      var classes = element.getAttribute('class');
      if (!classes) {
         classes = '';
      }
      var newClasses = '';
      var aClasses = classes.split(' ');
      for (var i = 0; i < aClasses.length; i++) {
         if (aClasses[i] !== cls) {
            if (newClasses.length > 0) {
               newClasses += ' ';
            }
            newClasses += aClasses[i]
         }
      }
      element.setAttribute('class', newClasses)
   }
   ret.padleft = function (where, what, length) {
      var ret = where ? where : '';
      while (ret.length < length) {
         ret = what + ret;
      }
      return ret;
   }

   ret.getUrlParameter = function (parameterName) {
      return  urlParams.get(parameterName);
   }
   ret.listUrlParameters = function () {
      let res = {}
      urlParams.forEach((value, key) =>{ res[key] = value});
      return res;
   }
   
   ret.isSpaceBar = function (pressedKey) {/*Esto podría convertirse en una función más compleja en la que se pase por parámetro la tecla que se quiere comprobar y esta tenga en las constantes su keycode/code/key para hacer el assert.*/ 
      return Boolean(pressedKey.key == " " || pressedKey.keyCode == Constants.KEY_CODES.SPACE || pressedKey.code == "Space")
   }
   return ret;
})();

function FEngineException(message) {
   this.message = message;
}

function FE$ValidatorEngine(translationSvc, valueProviderSvc) {
   var VALIDATORCLASSES = {};
   var VALIDATORINSTANCES = {};

   this.registerValidator = function (vclass, instance) {
      var type = instance.getType();
      var forControl = instance.getForControl();
      var forVariant = instance.getForVariant();

      if (!type) {
         throw new FEngineException('Tried to register a validator without type');
      }
      console.log('[FE$ValidatorEngine] Registering validator with type ' + type + ', instance: ' + instance);
      instance._initialize(valueProviderSvc);
      if (!(type in VALIDATORCLASSES)) {
         console.log('[FE$ValidatorEngine] Registered validator type ' + type);
         VALIDATORCLASSES[type] = vclass;
         VALIDATORINSTANCES[type] = instance;
      }

      if (!(type + '_' + forControl) in VALIDATORCLASSES) {
         VALIDATORCLASSES[type + '_' + forControl] = vclass;
         VALIDATORINSTANCES[type + '_' + forControl] = instance;
      }
      VALIDATORCLASSES[type + '_' + forControl + '_' + forVariant] = vclass;
      VALIDATORINSTANCES[type + '_' + forControl + '_' + forVariant] = instance;

      console.log('[FE$ValidatorEngine] Registered validator type ' + type + ' and control ' + forControl);
   }

   function getValidatorFor(configuration, ctrType, ctrVariant) {
      var type = configuration.type;
      var variant = configuration.variant;
      // console.log('[FE$ValidatorEngine] Checking validator for type: ' + type);
      if (!type) {
         throw new FEngineException('Wrong configuration for validator, no type defined');
      }
      if (!(type in VALIDATORINSTANCES)) {
         throw new FEngineException('No validator registered for type ' + type);
      }
      // Check if we have a control specific validator

      var ret = VALIDATORINSTANCES[type + '_' + ctrType + '_' + ctrVariant];
      if (!ret) {
         console.log('[FE$ValidatorEngine] No variant validator "' + type + '_' + ctrType + '_' + ctrVariant + '"...trying type validator');
         ret = VALIDATORINSTANCES[type + '_' + ctrType];
      }
      if (!ret) {
         console.log('[FE$ValidatorEngine] No type validator "' + type + '_' + ctrType + '"...trying default validator');
         ret = VALIDATORINSTANCES[type];
      }

      // console.log('[FE$ValidatorEngine]  Validator ' + ret + ' returned: ' + JSON.stringify(VALIDATORINSTANCES))
      return ret;

   }
   this.validate = function (value, ctrType, ctrVariant, valCfgs, lang) {
      console.log('[FE$ValidatorEngine] Validating with validators: ' + JSON.stringify(valCfgs));
      if (valCfgs == null) {
         return null;
      }

      if (Array.isArray(valCfgs)) {
         for (var i = 0; i < valCfgs.length; i++) {
            var v = getValidatorFor(valCfgs[i], ctrType, ctrVariant);

            var res = v.validate(value, valCfgs[i], translationSvc, lang);
            if (res) {
               return res;
            }
         }
      } else {
         throw new FEngineException('Wrong configuration found..validators is not an array: ' + JSON.stringify(valCfgs));
      }
      return res;
   }
}

function FE$DataConversionEngine() {
   var _configuration = [];
   var _dcInstancesMap = {}
   this.registerDataConversor = function (rclass, instance) {
      var type = instance.getType();
      console.log('[DC] Registered data converter ' + type)
      _dcInstancesMap[type] = instance;
   }

   this.configure = function (conversors) {
      if (!conversors) {
         return;
      }
      // Check configuration
      for (var i = 0; i < conversors.length; i++) {
         var type = conversors[i].type
         if (!type) {
            throw new FEngineException('No type defined for conversor on position ' + i);
         }
         if (!(type in _dcInstancesMap)) {
            throw new FEngineException('No conversor found with name ' + type)
         }
      }
      _configuration = conversors;
   }
   this.convert = function (values) {
      var currValues = values;
      for (var i = 0; i < _configuration.length; i++) {
         var type = _configuration[i].type;
         console.log('[DC] Converting using type ' + type);
         currValues = _dcInstancesMap[type].convert(currValues, _configuration[i]);
         console.log('[DC] Conversion returned ' + JSON.stringify(currValues));
      }
      if(!currValues?.cargos?.[0]?.entidad?.name)
         delete currValues.cargos;
      return currValues;
   }
}

function FE$RenderEngine(translateSvc) {
   var RENDERERCLASSES = {};
   var _ctrInstances = []
   var _ctrInstancesMap = {}

   this.registerRenderer = function (rclass, instance) {
      var type = instance.getType()
      var variant = instance.getVariant()

      console.log('Type and variant for renderer are ' + type + ' / ' + variant)
      if (!type) {
         throw new FEngineException('Tried to register a renderer without type');
      }
      if (!(type in RENDERERCLASSES)) {
         RENDERERCLASSES[type] = rclass;
      }
      if (variant) {
         RENDERERCLASSES[type + '_' + variant] = rclass;
      }
   }


   this.renderControl = function (data, parent, lang, coreProxy) {
      console.log('Obtaining renderer for ' + data.type);

      var rendererClass = RENDERERCLASSES[data.type + '_' + data.variant];
      if (!rendererClass) {
         rendererClass = RENDERERCLASSES[data.type];
      }
      if (!rendererClass) {
         throw new FEngineException('Unknown renderer for type: ' + data.type + ' (variant: ' + data.variant + ')')
      }
      if (data.bindTo) {
         // Control is renderer elsewhere

      }

      // Transition from inheritance to composition
      var renderer = typeof rendererClass === 'function' ? new rendererClass(coreProxy.defaultLang) : Object.assign(rendererClass, {});
      renderer.setProxy(coreProxy);

      renderer._render(data, parent, lang);
      _ctrInstances.push(renderer)
      if (data.name) {
         if (data.name in _ctrInstancesMap) {
            throw new FEngineException('Found duplicated name in control list "' + data.name + '"');
         }
         console.log('[fe$Rdr] Rendering ' + data.name);
         _ctrInstancesMap[data.name] = renderer; // Associative map
      }
   }

   this.toggleInvalid = function (name, invalid, message) {
      _ctrInstancesMap[name].toggleInvalid(invalid, message);
   }

   this.clearAllInvalid = function () {
      for (var i = 0; i < _ctrInstances.length; i++) {
         _ctrInstances[i].toggleInvalid(false);
      }

   }

   this.setVisibility = function (name, visible, freeSpace) {
      _ctrInstancesMap[name].setVisible(visible, freeSpace);
   }

   this.notifyEventOnControlToControl = function (event, data, control, toControl) {
      console.log('[fe$Rdr] Notifying to ' + toControl + ' of ' + event + ' on ' + control);
      _ctrInstancesMap[toControl].onEvent(event, data, control);
   }

   this.notifyEventToAllControls = function (event, data) {
      for (var i = 0; i < _ctrInstances.length; i++) {
         _ctrInstances[i].onEvent(event, data, null);
      }
   }

   this.translateControls = function (lang) {
      if (_ctrInstances.length == 0) {
         return; // Nothing to translate yet
      }
      for (var i = 0; i < _ctrInstances.length; i++) {
         _ctrInstances[i]._translateTo(lang);
      }
   }
   this.countAttachedFilesForDestination = function (dest) {
      var total = 0;
      for (var i = 0; i < _ctrInstances.length; i++) {

         if (_ctrInstances[i].isFileControl() && _ctrInstances[i].getDestination() == dest) {
            var attached = _ctrInstances[i].countFiles();
            total += attached;
            console.log('[fe$Rdr] Found file control ' + (attached > 0 ? ' WITH  ' : 'without') + attached + ' files');

         }
      }
      return total;
   }

   this.hasInternalUploads = function () {
      for (var i = 0; i < _ctrInstances.length; i++) {

         if (_ctrInstances[i].isFileControl() && _ctrInstances[i].getDestination() === undefined) {
            console.log('[fe$Rdr] Found file control');
            return true; // Check if it sends to sf or to other site
         }
      }
      return false;
   }

   this.getUploadDestinations = function () {
      var ret = [];
      var cache = {};
      for (var i = 0; i < _ctrInstances.length; i++) {

         if (_ctrInstances[i].isFileControl()) {
            var destination = _ctrInstances[i].getDestination();
            if (destination !== undefined && !(destination in cache)) {
               cache[destination] = true;
               ret.push(destination);
            }

         }
      }
      return ret;
   }

   this.getFileHandlerForControlAndIndex = function (name, index) {
      return _ctrInstancesMap[name].getFile(index);
   }
   this.getFileControlDescriptorsForDestination = function (destination, includeHidden) {
      var ret = new Array();
      for (var i = 0; i < _ctrInstances.length; i++) {

         if (!includeHidden && !_ctrInstances[i].isVisible()) {
            continue;
         }

         var def = _ctrInstances[i].getDefinition();
         if (_ctrInstances[i].isValueControl() && _ctrInstances[i].isFileControl()) {
            if (destination != _ctrInstances[i].getDestination()) {
               continue;
            }
            var value = _ctrInstances[i].getValue();

            var ctrData = { "name": def.name, "files": value };
            ret.push(ctrData);
         }
      }
      return ret;
   }

   this.getParametersForUploadDestination = function (destination, includeHidden) {
      var ret = {};
      for (var i = 0; i < _ctrInstances.length; i++) {

         if (!includeHidden && !_ctrInstances[i].isVisible()) {
            continue;
         }

         var def = _ctrInstances[i].getDefinition();
         if (_ctrInstances[i].isValueControl() && _ctrInstances[i].isFileControl()) {
            if (destination != _ctrInstances[i].getDestination()) {
               continue;
            }
            if (_ctrInstances[i].countFiles() == 0) {
               continue; // No files so no need for destination parameters
            }
            var values = _ctrInstances[i].getDestinationParameters();
            for (var k in values) {
               ret[k] = values[k];
            }
         }
      }
      return ret;
   }

   this.getFileControlData = function (name, index) {
      return _ctrInstancesMap[name].getFileData(index);
   }

   this.setValues = function (fValues) {
      for (var k in fValues) {
         // Property can have name and property...
         var parts = k.split('.');
         var ctrName = parts[0];
         if (ctrName in _ctrInstancesMap) {
            console.log('[fe$Rdr] Setting value to ' + k + ' with ' + fValues[k]);
            _ctrInstancesMap[ctrName].setValue(fValues[k], k);
         }

      }
   }

   this.getValues = function (includeHidden) {
      var ret = {interests : ""}
      var interests = []
      ret['interests.array']=[]
      console.log('[FE$RE] Sending values (hidden? ' + includeHidden + ')');
      for (var i = 0; i < _ctrInstances.length; i++) {
         console.log('[FE$RE] getting value ' + i + ' / ' + _ctrInstances.length);
         if (_ctrInstances[i].isValueControl()) {
            var def = _ctrInstances[i].getDefinition()
            // console.log('Interpreting definition: ' + JSON.stringify(def));
            var name = def.name
            if (!includeHidden && !_ctrInstances[i].isVisible()) {
               continue;
            }
            var value = _ctrInstances[i]._getValue()
            if (typeof value == 'string' || typeof value == 'boolean' || typeof value == 'number') {
               console.log('[FE$RE] Added simple ' + name + ' -> ' + value)
               ret[name] = value
            } else if (Array.isArray(value)) {
               // Keep as it is
               ret[name] = value;
            } else if (typeof value == 'object') {
               console.log('[FE$RE] Handling ' + name + ' as complex value');
               for (var k in value) {
                  if (value.hasOwnProperty(k)) {
                     var key = name;
                     if (k != '') 
                        key += '.' + k;
                     if(name.startsWith('interes'))
                        if(k == 'array')
                           ret['interests.array'] = [...ret['interests.array'], ...value[k]]
                        else
                           interests.push(value[k]);
                     else
                        ret[key] = value[k];
                     console.log('[FE$RE] Added ' + key + ' -> ', ret[key]);
                  }
               }
            } else {
               console.error('[FE$RE] Unknown value ' + value + ' on control ' + name);
               throw new FEngineException('Unknown value returned "' + value + '" on control ' + name);
            }

         }
      }
      
      if(interests.length>0)
         ret.interests = interests.join(',')
      else
         delete ret.interests

      return ret
   }
   this.getValue = function (name, includeHidden) {
      if (!(name in _ctrInstancesMap)) {
         console.log('Instances: ' + JSON.stringify(_ctrInstancesMap));
         for (var i in _ctrInstancesMap) {
            console.log('Instance available: ' + i)
         }
         throw new FEngineException('No control named "' + name + '" found in form');
      }
      if (includeHidden !== true && !_ctrInstancesMap[name].isVisible()) {
         return null;
      }
      return _ctrInstancesMap[name]._getValue();
   }

   this.getValueNoValidation = function (name) {
      if (!(name in _ctrInstancesMap)) {
         console.log('Instances: ' + JSON.stringify(_ctrInstancesMap));
         for (var i in _ctrInstancesMap) {
            console.log('Instance available: ' + i)
         }
         throw new FEngineException('No control named "' + name + '" found in form');
      }
      return _ctrInstancesMap[name].getValue();
   }

   this.areValid = function (includeHidden) {
      var messages = {}
      for (var i = 0; i < _ctrInstances.length; i++) {
         var name = _ctrInstances[i].getDefinition().name;
         if (_ctrInstances[i].isValueControl() && (includeHidden || _ctrInstances[i].isVisible())) { // Invisible fields are not needed 
            console.log('[FE$RE] Validating ' + name)
            var error = _ctrInstances[i].isValid()
            if (error) {
               console.log('[FE$RE] ' + name + ' error: ' + error);
               messages[name] = error;
            }
         }
      }
      return messages
   }

   this.lock = function (doLock) {
      for (var i = 0; i < _ctrInstances.length; i++) {
         _ctrInstances[i].lock(doLock);
      }
   }

   this.countControls = function () {
      return _ctrInstances.length
   }

}

window.fe$ngine = (function () {

   console.log('Generating fengine');

   /* ------------ INITIALIZE ------------ */
   var DEFAULT_LANG = Constants.DEFAULT_LANG;

   var JSONKEY_SENDHIDDEN = 'sendHidden';


   var REFPREFIX_RESPONSE = 'response';
   var REFPREFIX_REQUEST = 'request';
   var KEY_LANG = 'lang';

   var PREFIX_CAPTUREDREQPARAMS = REFPREFIX_REQUEST + '.';

   // Actions for submit success
   var ACTION_SHOWSUCCESS = 'success';
   var ACTION_EXECUTE = 'execute';
   var ACTIONTIME_IMMEDIATE = 'immediate';

   // Steps

   var STEP_INIT = 'start';
   var STEP_FORM = 'form';
   var STEP_SUCCESS = 'success';

   var _lang = DEFAULT_LANG;
   var _instance = {}
   var _root = null;
   var _def = null;
   var _ctrDefs = null;
   var _translations = null;

   var _domready = false;
   var _engineready = false;
   var _engineerrors = null;

   var _deferredRender = null;

   var _renderEngine = null; // Defer until we have the translation method
   var _validatorEngine = null;
   var _dconversorEngine = null;
   var _dataProviderSvc = null;

   var _resourceFiles = []
   var _resourcesLoaded = 0;
   var _titleNode = null;
   var _iconNode = null;

   var _unexpectedCallback = null;
   var _renderCallback = null;
   var _validationCallback = null;
   var _submitCallback = null;
   var _langChangeCallback = null;

   var _redirectionService = null;
   var _showSuccessService = null;

   var _isLocked = false;

   var _lastValue = {};
   var _lastResponse = {};

   var _subscriptionMap = {} // a. { type:'control', item: controlObj }
   // b. { type:'function', item: fnc }
   var _fexiExecutor = new FE$BaseFunctionExecutor();

   function _translate(args) {
      return translate(args[0], _lang);
   }
   _fexiExecutor.addFunction('translate', _translate.bind(this));

   // This method permits calls one function by name 
   function _call(args) {
      if (args.length < 1) return;
      var name = args.shift();
      if (typeof window[name] == 'function') {
         return window[name](args);
      }
      return null;
   }
   // Add call function
   _fexiExecutor.addFunction('call', _call.bind(this));

   // Add call function
   _fexiExecutor.addFunction('step', () => {
      return fe$ngine._step;
   });

   function _redirect(args) {
      console.log('Invoking redirection to ', args);
      var url = args[0];
      var hasParams = url.indexOf('?') != -1;
      for (var i = 1; i < args.length; i += 2) {
         if (hasParams) {
            url += '&'
         } else {
            url += '?'
            hasParams = true;
         }
         url += args[i] + '=' + args[i + 1]
      }
      console.log('Redirection generated url: ' + url);
      _redirectionService(url);
      return null;
   }
   // Add redirection function
   _fexiExecutor.addFunction('redirect', _redirect.bind(this));

   function _isEmpty(args) {
      return args[0] == null || args[0].length == 0
   }
   _fexiExecutor.addFunction('isEmpty', _isEmpty.bind(this));

   function _normalizeIdCard(args) {
      if (args[0] === null || args[0] === undefined || typeof args[0] != 'string') {
         return args[0];
      }

      return args[0].toUpperCase().replace(/[^0-9A-Z]/g, '');
   }
   _fexiExecutor.addFunction('normalizeIdCard', _normalizeIdCard.bind(this));

   function _validateDNINIE(args) {
      const dni = args[0]?.toUpperCase();
      const validator = /^[XYZ]?\d{5,8}[A-Z]$/;
      if (!dni?.match(validator))
         return false;

      let number = dni.substring(0, dni.length - 1),
         lastLetter = dni.substring(dni.length - 1),
         validFinalLetters = 'TRWAGMYFPDXBNJZSQVHLCKET',
         nieLetters = ['X', 'Y', 'Z'];

      nieLetters.forEach((letter, index) => number = number.replace(letter, index))


      return validFinalLetters.indexOf(lastLetter) === number % 23;
   }
   _fexiExecutor.addFunction('validateDNINIE', _validateDNINIE.bind(this));

   function _validatePassport(args) {
      const passport = args[0];
      const validator = /^[a-z]{3}[0-9]{6}[a-z]?$/i;

      return Boolean(passport?.match(validator));
   }
   _fexiExecutor.addFunction('validatePassport', _validatePassport.bind(this));

   function _historyBack() {
      console.log('Success accepted');
      if(!window.history.back())
         window.close()
   }
   _fexiExecutor.addFunction('historyBack', _historyBack.bind(this));

   function _addControlSubscription(event, toControl, subscriber) {
      if (toControl.indexOf('response.') == 0) {
         toControl = 'response'; // In case of subscribing to a field in response we actually subscribe to the response
      }
      var subsToControl = _subscriptionMap[toControl]
      if (!subsToControl) {
         subsToControl = {}

         _subscriptionMap[toControl] = subsToControl;
      }
      var subsForEvent = subsToControl[event]
      if (!subsForEvent) {
         subsForEvent = []
         subsToControl[event] = subsForEvent;
      }

      subsForEvent.push(subscriber);
      console.log('[fe$ngine] Subscribed to event "' + event + '" -> ' + subsForEvent.length);
   }

   function _subscribeControlTo(event, toControl, byControl) {
      console.log('[fe$ngine] Subscribing ' + byControl + ' to ' + event + ' on ' + toControl);
      _addControlSubscription(event, toControl, { type: 'control', item: byControl });
   }

   function subscribeFunctionTo(event, toControl, fnc) {
      console.log('[fe$ngine] Subscribing control ' + toControl + ' function ' + fnc + ' on ' + event);
      _addControlSubscription(event, toControl, { type: 'function', item: fnc });
   }



   function updateAllVisibilities() {
      for (var i = 0; i < _ctrDefs.length; i++) {
         if ('visibleIf' in _ctrDefs[i]) {
            updateVisibility(_ctrDefs[i]);
         }
      }
   }

   function processThankYouPageValues() {
      if(!FE$XInterpreter || !fe$ngine){
         console.log("[processThank] No se ha podido utilizar FE$XInterpreter");
         return;
      }
      let values = {}
      _ctrDefs.filter(ctrl => ctrl.process?.step === STEP_SUCCESS && ctrl?.bindTo ==='id=thanks' && 'name' in ctrl)
               .forEach(ctrl => values[ctrl.name] = fe$ngine.executeAST(FE$XInterpreter.parse(ctrl.process.action)));
      
      _renderEngine.setValues(values)
   }
   
   function _idSolver(ctrName, asObject) {
      console.log('[fe$ngine] Getting value of ' + ctrName);
      // var fieldName = '';
      if (KEY_LANG == ctrName) {
         console.log('[fe$ngine] Setting lang in request');
         return _lang;
      }

      console.log('[fe$ngine] Obtaining value for control "' + ctrName + '"')
      var ret = null;
      if (ctrName == REFPREFIX_RESPONSE) {
         console.log('[fe$ngine] Value for ' + ctrName + ' on ', _lastResponse);
         ret = _lastResponse;
         if (ret === undefined) {
            return '_';
         }
      } else if (ctrName == REFPREFIX_REQUEST) {
         ret = fe$utils.listUrlParameters();
      } else {
         var ctrVal = _renderEngine.getValueNoValidation(ctrName);
         console.log('[fe$ngine] Value of ' + ctrName + ' -> ', ctrVal, typeof ctrVal);
         if (ctrVal == null) {
            return null;
         }
         var type = typeof ctrVal;
         if (asObject === true) {
            ret = ctrVal;
         } else if (type != 'string' && type != 'number' && type != 'boolean') {
            console.log('[fe$ngine] Complex type obtained...getting ""');

            ret = ctrVal['']
         }
         if (ret === undefined) {
            console.log('[fe$ngine] No value found for "" on control ' + ctrName);
            return null;
         }
      }
      console.log('[fe$ngine] Id ' + ctrName + ' solved with value: "' + ret + '"');
      return ret;

   }
   function updateVisibility(ctrDef) {
      console.log('[fe$ngine] Updating visibility to: ', ctrDef);

      var ret = FE$XInterpreter.evaluate(ctrDef.visibleIf.ast, _idSolver, _fexiExecutor.getFunctionSolver());
      console.log('[fe$ngine] Visibility evaluated as: ' + ret);
      _renderEngine.setVisibility(ctrDef.name, ret, ctrDef.visibleIf.freeSpace == true);

   }


   function _getSubscribedToControl(event, onControl) {
      var subsOnControl = _subscriptionMap[onControl]
      if (!subsOnControl) {
         return [];
      }
      var subsForEvent = subsOnControl[event];
      if (!subsForEvent) {
         return [];
      }
      return subsForEvent;
   }

   function _onEvent(event, who) {
      console.log('[fe$ngine] Detected ' + event + ' on ' + who);
      var subscribed = _getSubscribedToControl(event, who);
      console.log('[fe$ngine] Notifying ' + subscribed.length + ' subscribers of ' + event);
      for (var i = 0; i < subscribed.length; i++) {
         var subs = subscribed[i];
         console.log('[fe$ngine] Detected change on control', who, subs);
         if (subs.type == 'control') {
            _renderEngine.notifyEventOnControlToControl(event, null, who, subs.item);
         } else if (subs.type == 'function') {
            console.log('[fe$ngine] Detected change on control with function subscriber type: ', subs);
            subs.item();
         } else {
            console.log('[fe$ngine] Detected change on control with unknown subscriber type: ', subs);
         }
      }
   }

   function onResourcesReady(success, src, event) {
      if (!success) {
         throw new FEngineException('Unable to load resource ' + src);
      }
      if (src != null) {
         _resourcesLoaded++;
      }
      console.log('[fe$ngine] Resource ready: ' + src + ' total: ' + _resourcesLoaded + ' / ' + _resourceFiles.length);
      if (_resourcesLoaded == _resourceFiles.length) {
         console.log('[FE] All resources loaded')
         _engineready = true;

         if (_deferredRender) {
            _deferredRender();
            _deferredRender = null;
         }
      }
   }
   function onDOMReady() {
      _domready = true;
      console.log('[fe$ngine] DOM Ready.');
   }
   document.addEventListener('DOMContentLoaded', onDOMReady);

   /* ----------------- PRIVATE METHODS ---------------- */

   function cleanElements() {
      for (var i = 0; i < arguments.length; i++) {
         while (arguments[i].hasChildNodes()) {
            arguments[i].removeChild(arguments[i].firstChild)
         }
      }
   }

   function translateTitle() {
      // Translate also title
      if (_titleNode) {
         if (_titleNode.hasChildNodes()) {
            _titleNode.removeChild(_titleNode.firstChild)
         }

         _titleNode.appendChild(document.createTextNode(translate(_def.title, _lang)))
      }
   }

   function hasTranslationFor(message) {
      if (!(message in _translations)) {
         return false;
      }
      return true;
   }
   function translate(what, lang) {

      if (what.indexOf('#') != 0) {
         return what;
      }
      if (_translations) {
         var translation = _translations[what]
         // console.log('Translating using: ' + JSON.stringify(translation))
         if (!translation) {
            return "No translation for reference: " + what
         }
         if (lang in translation) {
            return translation[lang]
         } else if (DEFAULT_LANG in translation) {
            // console.log('No lang in translation for lang ' + lang + ' -> ' + translation[lang])
            return translation[DEFAULT_LANG]
         }

         return "No translation for " + what + " for language " + lang + "(Nor default lang " + DEFAULT_LANG + ")"
      } else {
         return "No translations defined"
      }
   }
   // Create the render engine with the translate function
   _renderEngine = new FE$RenderEngine(translate);
   _validatorEngine = new FE$ValidatorEngine(translate, _renderEngine.getValue);
   _dconversorEngine = new FE$DataConversionEngine();

   function enableGTM(keys) {
      console.log('[fe$ngine] Enabling gtm keys: ' + keys);
      if (!('dataLayer' in window)) {

         window.dataLayer = [];
         console.log('[fe$ngine] Created GTM in window: ' + window.dataLayer);
      } else {
         console.log('[fe$ngine] GTM already found in window');
      }
      for (var i = 0; i < keys.length; i++) {

         window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
         var scr = document.createElement('script');
         scr.src = 'https://www.googletagmanager.com/gtm.js?id=' + keys[i];
         document.head.appendChild(scr);
      }
   }

   function enableFacebookPixel(key) {
      console.log('[fe$ngine] Enabling facebook pixel: ' + key);

      var str = '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,\'script\',\'https://connect.facebook.net/en_US/fbevents.js\');fbq(\'init\', \''
         + key
         + '\');fbq(\'track\', \'PageView\');';
      console.log('[fe$ngine] Injecting fb pixel "' + str + '"');
      eval(str);
   }

   /** 
    * Function that parses validation conditions to prepare for submitting
    */
   function compileGlobalValidations(validations) {
      for (var i = 0; i < validations.length; i++) {
         if (window.location.href.indexOf('file://') != 0) {
            console.log('[fe$ngine] Async compilation');
            FE$XInterpreter.parseAsync(validations[i].condition, function (validation, ast) {
               console.log('[fe$ngine] *** Compiled async condition to: ' + JSON.stringify(ast));
               validation.ast = ast;
            }.bind(this, validations[i]));
            console.log('[fe$ngine] *** Parsing condition: ' + validations[i].condition);
         } else {
            console.log('[fe$ngine] Sync compilation');
            validations[i].ast = FE$XInterpreter.parse(validations[i].condition);
         }
      }
   }
   /* ----------------- PUBLIC METHODS ----------------- */
   /** Available events */
   _instance.Events = {
      CHANGE: 'change',
      FORMREADY: 'formready'
   }

   //step system
   _instance._step = STEP_INIT;

   /* Returns list langs defined in the configuration passed as param */
   _instance.getLangsForDef = function (data) {
      var ret = []
      if (data.langs) {
         if (Array.isArray(data.langs) && data.langs.every(l => Constants.VALID_LANGUAGES.includes(l))) {
            ret = data.langs;
         } else {
            console.log('[fe$ngine] Langs defined in font are incorrect: ' + JSON.stringify(data.langs));
         }
      }

      if (ret.length == 0) {
         console.log('[fe$ngine] Getting lLngs from translations ');
         var hash = {}
         if ('translations' in data) {
            for (var k in data.translations) {
               for (var l in data.translations[k]) {
                  if (!(l in hash)) {
                     hash[l] = true;
                     ret.push(l);
                  }
               }
            }
         }
      }

      console.log('[fe$ngine] Langs available: ' + ret);
      return ret;
   }

   /**
    * Method that tells whether the rendered form contains upload controls sending
    * to salesforce
    */
   _instance.hasInternalUploads = function () {
      return _renderEngine.hasInternalUploads();
   }
   _instance.getUploadExternalDestinations = function () {
      return _renderEngine.getUploadDestinations();
   }
   _instance.getFileHandlerForControlAndIndex = function (name, index) {
      return _renderEngine.getFileHandlerForControlAndIndex(name, index);
   }
   _instance.getParametersForUploadDestination = function (destination, includeHidden) {
      return _renderEngine.getParametersForUploadDestination(destination, includeHidden);
   }

   _instance.onExternalEvent = function (event, source, data) {
      // Notify the external change
      console.log('[fe$ngine] External change detected on ' + source);
      if (source == 'response') {
         _lastResponse = data;
      }
      _onEvent(event, source);
   }


   /**
    * Used mainly for those messages coming from server but not used internally
    */
   _instance.getTranslationFor = function (message, defaultMessage) {
      if (hasTranslationFor(message)) {
         return translate(message, _lang);
      }
      console.log('[fe$ngine] No translation for ' + message, _translations);
      return defaultMessage;
   }
   _instance.getDefaultLangForDef = function (data) {
      var ret = null;
      if ('defLang' in data) {
         ret = data.defLang;
      } else {
         var langs = this.getLangsForDef(data);
         if (langs.length > 0) {
            ret = langs[0]
         }
      }
      console.log('[fe$ngine] Default language: ' + ret)
      return ret;
   }

   /* Initializes engine and load configured resources */
   _instance.initialize = function () {
      console.log('[FE] Initializing');
      if (!_unexpectedCallback) {
         throw new FEngineException('Unexpected callback not set...cannot "initialize"');
      }
      if (!_submitCallback) {
         throw new FEngineException('Submit callback not set...cannot "initialize"');
      }

      if (!_domready) {
         throw new FEngineException('Do not call initialize until DOM is properly loaded');
      }
      if (_engineready) {
         throw new FEngineException('Already initialized');
      }
      if (_dataProviderSvc != null && typeof _dataProviderSvc !== 'function') {
         throw new FEngineException('Wrong data provider. Expected function');
      }


      // Load resources
      if (_resourceFiles.length > 0) {
         console.log('[FE] Loading resources: ' + _resourceFiles);
         for (var i = 0; i < _resourceFiles.length; i++) {

            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = _resourceFiles[i]
            script.onreadystatechange = onResourcesReady.bind(this, true, script.src);
            script.onload = onResourcesReady.bind(this, true, script.src);
            script.onerror = onResourcesReady.bind(this, false, script.src);
            console.log('[fe$ngine] Loading resource: ' + script.src);
            document.head.appendChild(script);
         }
      } else {
         onResourcesReady(true, null);
      }
      return _instance;
   }
   _instance.addResource = function (file) {
      if (_engineready) {
         throw new FEngineException('Cannot add resources after engine has been initialized');
      }
      _resourceFiles.push(file);
      return _instance;
   }
   _instance.setRenderCallback = function (callback) {
      _renderCallback = callback;
      return _instance;
   }
   _instance.setValidationCallback = function (callback) {
      _validationCallback = callback;
      return _instance;
   }
   _instance.setUnexpectedCallback = function (callback) {
      console.log('[FE] Setting unexpected callback');
      _unexpectedCallback = callback;
      return _instance;
   }
   _instance.setLangChangeCallback = function (callback) {
      console.log('[FE] Setting lang change callback');
      _langChangeCallback = callback;
      return _instance;
   }

   _instance.setSubmitCallback = function (callback) {
      _submitCallback = callback;
      return _instance;
   }
   // Data provider function must conform to fnc(params, callback)
   _instance.setDataProvider = function (dp) {
      _dataProviderSvc = dp;
      return _instance;
   }

   _instance.setRedirectionService = function (service) {
      _redirectionService = service;
      return _instance;
   }
   _instance.setShowSuccessService = function (service) {
      _showSuccessService = service;
      return _instance;
   }

   _instance.executeString = function (expression) {
      console.log('[FE] Executing string "' + expression + '" on this?' + (this == _instance));
      var ast = FE$XInterpreter.parse(expression);

      var ret = this.executeAST(ast);
      return ret;
   }

   _instance.executeAST = function (ast) {
      var ret = FE$XInterpreter.evaluate(ast, _idSolver, _fexiExecutor.getFunctionSolver());

      console.log('[FE] Result of string execution: ' + ret);
      return ret;
   }

   _instance.render = function (data) {
      if (!_domready) {
         throw new FEngineException('Do not call render until DOM is properly loaded');
      }
      if (!_engineready) {
         console.log('[FE] Deferring render')
         _deferredRender = _instance.render.bind(this, data);
         return;
      }
      _def = data;
      if (_renderCallback) {
         _renderCallback(true);
      }
      console.log('[FE] Rendering data');
      console.log('[FE] REALLY Initializing....with ' + JSON.stringify(data))


      var definitionDefLang = this.getDefaultLangForDef(_def);
      if (definitionDefLang != null) {
         DEFAULT_LANG = definitionDefLang; // Set default language to the one from definition
      }
      if (_def.translations) {
         _translations = _def.translations;
      }
      // Configure data conversor engine
      if (_def.conversions) {
         _dconversorEngine.configure(data.conversions)
      }
      var bindTo = data.bindTo;
      if (!bindTo) {
         throw new FEngineException('No attribute bind to found. Stopped');
      }
      // Solve ctrDefs
      var ctrDefs = null;
      if (!data.form) {
         throw new FEngineException('FORM Controls not defined: ' + JSON.stringify(ctrDefs));
      }
      if (Array.isArray(data.form)) {
         ctrDefs = data.form;
      } else if (typeof data.form == 'object') {
         // Handle different keys
         ctrDefs = new Array();

         // Get groups to render
         if (!('groups' in data)) {
            throw new FEngineException('Form definition includes groups but does not include group order');
         }
         console.log('[FE] Serving groups ' + data.groups);
         for (var k = 0; k < data.groups.length; k++) {
            var group = data.groups[k];
            console.log('[FE] Handling group ' + group);
            if (!(group in data.form)) {
               console.log('[FE] WARNING - Ignoring group ' + group + '. Not found');
               continue;
            }
            if (!Array.isArray(data.form[group])) {
               throw new FEngineException('Group ' + group + ' is not defined as an array of controls as expected\n' + JSON.stringify(ctrDefs));
            }
            console.log('[FE] Rendering group: ' + group);

            for (var i = 0; i < data.form[group].length; i++) {
               ctrDefs.push(data.form[group][i]);
            }
         }

      }

      if ('validIf' in _def) {
         if (!Array.isArray(_def.validIf)) {
            throw new FEngineException('Invalid global validations found. Expected array, found ' + _def.validIf);
         }
         compileGlobalValidations(_def.validIf);
      }

      if (ctrDefs.length == 0) {
         throw new FEngineException('No control definitions found');
      }

      // Handle gtm keys if any
      if (_def.gtmKeys && Array.isArray(_def.gtmKeys)) {
         enableGTM(_def.gtmKeys);
      }

      if (_def.fbPixKey) {
         enableFacebookPixel(_def.fbPixKey);
      }

      if (_def.title) {
         var titles = document.getElementsByTagName('title');
         _titleNode = document.createElement('title');
         if (titles) {
            _titleNode = titles[0];
            translateTitle()
         }

         document.head.appendChild(_titleNode);
      }
      if (_def.favicon) {
         var links = document.getElementsByTagName('link')
         for (var i = 0; i < links.length; i++) {
            if ('icon' === links[i].getAttribute('rel')) {
               _iconNode = links[i];
               break;
            }
         }
         if (_iconNode == null) {
            _iconNode = document.createElement('link');
            _iconNode.setAttribute('rel', 'icon');
            document.head.appendChild(_iconNode);
         }
         var type = '';
         if (data.favicon.indexOf('.') != -1) {
            type = data.favicon.substring(data.favicon.lastIndexOf('.') + 1, _def.favicon.length);
         }
         _iconNode.setAttribute('type', 'image/' + type)

         _iconNode.setAttribute('href', _def.favicon);

      }

      /* SF_A-2085 Injected custom css's */
      if (_def.injectedCss) {
         var csss = null;
         if (Array.isArray(_def.injectedCss)) {
            csss = _def.injectedCss;
         } else {
            csss = [_def.injectedCss];
         }
         for (var i = 0; i < csss.length; i++) {
            var cssEl = document.createElement('link');
            cssEl.setAttribute('rel', 'stylesheet');
            cssEl.setAttribute('type', 'text/css')
            cssEl.setAttribute('href', csss[i]);

            document.head.appendChild(cssEl);
         }
      }


      if (_def.cssClass) {
         fe$utils.addClass(_def.cssClass, document.body);
      }

      var formElement = _instance.solveBindTo(bindTo)
      if (!formElement) {
         throw new FEngineException('Unable to locate form root element: ' + bindTo)
      }

      // Assign vars if everything is ok
      _ctrDefs = ctrDefs;
      _root = formElement;

      var bindings = { bindTo: _root }

      for (var i = 0; i < _ctrDefs.length; i++) {
         console.log('Checking bindings for ' + JSON.stringify(_ctrDefs[i]));
         if ("bindTo" in _ctrDefs[i] && !(_ctrDefs[i].bindTo in bindings)) {
            var newBinding = _instance.solveBindTo(_ctrDefs[i].bindTo);
            if (newBinding) {
               bindings[_ctrDefs[i].bindTo] = newBinding
               console.log('Bind to ' + _ctrDefs[i].bindTo + ' is ' + bindings[_ctrDefs[i].bindTo])
            }

         } else {
            console.log('No binding found for: ' + JSON.stringify(_ctrDefs[i]) + ' -? ' + ("bindTo" in _ctrDefs[i]))
         }
      }
      cleanElements.apply(this, Object.values(bindings));
      try {
         // Define an event handler/subscriber
         var coreProxy = new (function () {
            this.Events = _instance.Events;
            this.subscribeTo = _subscribeControlTo; // Used to subscribe to changes on other controls
            this.onEvent = _onEvent; // Used to inform of changes on the control
            this.queryData = _dataProviderSvc;
            this.validate = _validatorEngine.validate;
            this.defaultLang = DEFAULT_LANG;
            this.translate = translate;
            this.getValueOf = _renderEngine.getValueNoValidation;

            this.fexExecuteString = _instance.executeString.bind(_instance);
            this.fexParseAST = FE$XInterpreter.parse.bind(FE$XInterpreter);
            this.fexExecuteAST = _instance.executeAST;
            this.fexGetASTIdentifiers = FE$XInterpreter.getIdentifiers.bind(FE$XInterpreter);
         })();
         let tabIndex = 0;
         for (var i = 0; i < _ctrDefs.length; i++) {
            console.log('Called render control with ' + JSON.stringify(_ctrDefs[i]))
            var parent = _root
            if (_ctrDefs[i].bindTo) {

               parent = bindings[_ctrDefs[i].bindTo]
            }
            console.log('Rendering control binded to ' + _ctrDefs[i].bindTo)
            if (!parent) {
               // throw new FEngineException('Unable to locate element with binding: ' + _ctrDefs[i].bindTo)
               console.log('[WARNING] No binding found for ' + _ctrDefs[i].bindTo)
            } else {
               console.log('[fe$ngine] Rendering control with lang ' + _lang + ', def lang: ' + DEFAULT_LANG);
               // Handle visibility conditions
               if ('visibleIf' in _ctrDefs[i]) {
                  console.log('[fe$ngine] Detected visibility condition: ', _ctrDefs[i].visibleIf);
                  _ctrDefs[i].visibleIf.ast = FE$XInterpreter.parse(_ctrDefs[i].visibleIf.condition);

                  console.log('[fe$ngine] Ast compiled as: ', _ctrDefs[i].visibleIf.ast);

                  var ids = FE$XInterpreter.getIdentifiers(_ctrDefs[i].visibleIf.ast);
                  console.log('[fe$ngine] AST contains ids: ', ids);
                  for (var d = 0; d < ids.length; d++) {
                     subscribeFunctionTo(_instance.Events.CHANGE, ids[d], updateVisibility.bind(this, _ctrDefs[i]));
                  }
               }
               tabIndex += 100
               _ctrDefs[i].tabIndex = tabIndex
               _renderEngine.renderControl(_ctrDefs[i], parent, _lang, coreProxy);
               
               tabIndex = _ctrDefs[i].tabIndex
            }
         }

         // Render hardcoded footer
         var footer = document.getElementsByTagName('footer');
         let fData;
         if (footer && footer.length > 0) {
            fData = { 'type': 'hcfooter', 'name': 'footer' }
            if (_def.footer) {
               fData = Object.assign(_def.footer, fData);
            }
            else if (_def.extensions && _def.extensions.oacsource) {
               fData = Object.assign({ 'oacsource': _def.extensions.oacsource }, fData);
            }
            _renderEngine.renderControl(fData, footer[0], _lang, coreProxy);
         }
         
         if(window.location.href.includes("form05")) {
            //Render hardcoded Footer ThankYouPage
            footer = document.getElementById('footerThanks');
            if (footer) {
               fData = { 'type': 'hcfooter', 'name': 'footerThanks' }
               if (_def.footer) {
                  fData = Object.assign(_def.footer, fData);
               }
               else if (_def.extensions && _def.extensions.oacsource) {
                  fData = Object.assign({ 'oacsource': _def.extensions.oacsource }, fData);
               }
               _renderEngine.renderControl(fData, footer, _lang, coreProxy);
            }
         }

         // Render hardcoded toast
         var toast = document.getElementsByTagName('body');
         if (_def.isTest)
            _renderEngine.renderControl({ 'type': 'toast', 'name': 'toast', 'version': 'error', 'traductions': Constants.TEST_MODE }, toast[0], _lang, coreProxy);

         this._step = STEP_FORM;

         updateAllVisibilities();

      } catch (e) {
         console.error('[fe$ngine] Captured exception ', e);

         _unexpectedCallback(e && e.message ? e.message : 'Unexpected');
      }
      //translateTitle();

      // Inform of controls that all of them have been rendered
      _renderEngine.notifyEventToAllControls(_instance.Events.FORMREADY);

      if (_renderCallback) {
         _renderCallback(false);
      }
   }

   _instance.solveBindTo = function (spec) {
      var ret = null;
      if (spec.indexOf('id=') == 0) {
         var sId = spec.substring(3, spec.length)
         console.log('Locating element: ' + sId)
         ret = document.getElementById(sId);
      }
      if (!ret) {
         console.log('Unable to solve bindTo: ' + spec)
      }
      return ret;
   }

   _instance.doSubmit = function () {
      _submitCallback();
   }

   var executeSuccessAction = function (act) {
      var exec = function () {
         var ast = FE$XInterpreter.parse(act.expression);
         var ret = FE$XInterpreter.evaluate(ast, _idSolver, _fexiExecutor.getFunctionSolver());
      }

      if (act.time && act.time != ACTIONTIME_IMMEDIATE) {
         if (typeof act.time != 'number') {
            console.error('[FE] Unable to understand time attribute of action: ' + JSON.stringify(act) + '. Expected number');
            return;
         }
         console.log('[FE] Delaying redirection ' + act.time + ' seconds');

         setTimeout(exec.bind(this), act.time * 1000);
      } else {
         console.log('[FE] Immediate execution of ' + act.expression);
         exec();
      }
   }

   _instance.resolveSuccess = function () {
      console.log('[FE] Resolving response with params: ' + JSON.stringify(_lastResponse));

      if ('submit' in _def && 'actions' in _def.submit) {
         for (var i = 0; i < _def.submit.actions.length; i++) {

            var act = _def.submit.actions[i];
            console.log('[FE] Executing action ' + JSON.stringify(act));
            if (act.type == ACTION_SHOWSUCCESS) {
               if (!_showSuccessService) {
                  console.log('[FE] No success service..unable to show it. Ignoring action: ' + JSON.stringify(act));
                  continue;
               }
               _showSuccessService();
            } else if (act.type == ACTION_EXECUTE) {
               executeSuccessAction(act);
            }
         }
         _showSuccessService && _showSuccessService();
      } else {
         console.log('[FE] Nothing defined for success...showing success dialog (' + JSON.stringify(_def.submit) + ')');
         if (_showSuccessService) {
            _showSuccessService();
         }

      }

      this._step = STEP_SUCCESS;
      processThankYouPageValues();
      updateAllVisibilities();
      _instance.getGoogleAnalyticsURLFromProxy();
   }
   
   _instance.getGoogleAnalyticsURLFromProxy = function () {
      if(!_def?.googleAnalytics) {
         return {};
      }
      let baseURL = 'https://cloud.news.fundacionlacaixa.org/ga4auth'
      
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/JSON");
      myHeaders.append("Access-Control-Allow-Methods","POST");
      myHeaders.append("Access-Control-Allow-Headers","Content-Type");

      var requestOptions = {
         method: 'POST',
         headers: myHeaders,
         redirect: 'follow',
         body: '{"eventName":"' + _def.googleAnalytics.name + '"}'
      };
      
      fetch(baseURL, requestOptions)
         .then(response => {console.log('[GAProxy] OK'); return response.json() })
         .then(proxyResponse => {
            console.log('[googleAnalyticsCall - proxyResponse] ', proxyResponse) 
            _instance.googleAnalyticsCall(proxyResponse);
         })
         .catch(error => {
            console.error('error', error)
      });
   }
   
   _instance.googleAnalyticsCall = function (urlData) {
      if(!urlData) {
         return;
      }

      const raw = {"client_id": '' + Date.now(), 
                     "non_personalized_ads": false,
                     "events": [{"name": _def.googleAnalytics.name,
                                 "params": {}
                        }]
                  }
      let FE_exception = false;
      for (var param in _def.googleAnalytics.params) {
         try {

            let valor = fe$ngine.executeString(_def.googleAnalytics.params[param]);
            raw.events[0].params[param] = '' + valor; //El valor tiene que ser un String

            if(typeof valor === "object" ) {
               raw.events[0].params[param] = 'null';
               if(valor?.['']) { //Los multipicklist devuelven un objeto que contiene una propiedad llamada '' con los valores separados por ";"
                     raw.events[0].params[param] = valor[''];
               }
            }
            
         } catch (error) {
            console.error('googleAnalyticsCall-error', error);
            FE_exception = true;
         }
      }
      if(FE_exception){
         return;
      }

      let baseURL = `https://www.google-analytics.com/mp/collect?api_secret=${urlData?.content?.api_secret}&measurement_id=${urlData?.content?.measurement_id}`
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "text/plain");
      myHeaders.append("Access-Control-Allow-Methods","POST");
      myHeaders.append("Access-Control-Allow-Headers","Content-Type");

      var requestOptions = {
         method: 'POST',
         headers: myHeaders,
         redirect: 'follow',
         body: JSON.stringify(raw),
         mode: 'no-cors'
      };
      
      fetch(baseURL, requestOptions)
         .then(response => {console.log('[googleAnalyticsCall] OK') })
         .catch(error => {
            console.error('googleAnalyticsCall-Fetch error', error)
      });
   } 

   _instance.register = function (rclass) {
      // console.log('------- Registering (inner) ' + rclass)
      var i = typeof rclass == 'function' ? new rclass() : rclass;

      var nature = i.nature();
      if (nature === 'renderer') {
         _renderEngine.registerRenderer(rclass, i);
      } else if (nature === 'validator') {
         _validatorEngine.registerValidator(rclass, i);
      } else if (nature === 'dataconverter') {
         _dconversorEngine.registerDataConversor(rclass, i);
      }
   }

   _instance.setLanguage = function (lang) {
      lang = lang?.toLowerCase();
      console.log('[fe$ngine] Translating to ' + lang);
      if(!Constants.VALID_LANGUAGES.includes(lang)) {
         console.log('[fe$ngine] Overriding lang specified (' + lang + ') with [es]');
         lang = Constants.DEFAULT_LANG;
      }
      _lang = lang;
      window.lang = _lang;
      if (_engineready) {
         updateAllVisibilities();
         _renderEngine.translateControls(lang);
      } else {
         console.log('[fe$ngine] Setting lang to ' + lang + ' before engine is ready and engine says: ' + _renderEngine.countControls() + ' controls');
      }

      translateTitle();
      if (_langChangeCallback) {
         _langChangeCallback(_lang);
      }
      return _instance;
   }

   _instance.getLanguage = function () {
      return _lang;
   }

   _instance.getBackground = function () {
      return (_lang && _def.background && _def.background[_lang]) || false;
   }

   _instance.getFileValuesForDestination = function (dest, includeData) {
      var sendHidden = _def[JSONKEY_SENDHIDDEN];
      var fileCtrDescriptors = _renderEngine.getFileControlDescriptorsForDestination(dest, sendHidden === true);

      if (fileCtrDescriptors.length > 0) {
         var total = 0;
         for (var i = 0; i < fileCtrDescriptors.length; i++) {
            total += fileCtrDescriptors[i].files.length;
         }
         console.log('[fe$ngine] Number of total files is: ' + total);
         if (includeData) {
            for (var ctrIdx = 0; ctrIdx < fileCtrDescriptors.length; ctrIdx++) {
               console.log('[fe$ngine] Reading files for: ' + JSON.stringify(fileCtrDescriptors[ctrIdx]));
               for (var fIdx = 0; fIdx < fileCtrDescriptors[ctrIdx].files.length; fIdx++) {
                  fileCtrDescriptors[ctrIdx].files[fIdx].data = _renderEngine.getFileControlData(fileCtrDescriptors[ctrIdx].name, fIdx);
               }
            }
         }
         return fileCtrDescriptors;
      } else {
         return [];
      }

   }

   // Tells whether the form contains any file to be sent (no upload controls...upload controls that have files set)
   _instance.countAttachedFilesForDestination = function (dest) {
      return _renderEngine.countAttachedFilesForDestination(dest);
   }

   // Sets values to all fields
   _instance.setValues = function (values) {
      _renderEngine.setValues(values);
   }

   _instance.getValues = function () {
      var sendHidden = _def[JSONKEY_SENDHIDDEN];
      console.log('Executing get values');
      var errors = _renderEngine.areValid(sendHidden === true);


      console.log('[fe$engine] Errors: ' + JSON.stringify(errors))
      if (fe$utils.isDictEmpty(errors)) {

         console.log('[fe$ngine] Send hidden configured as: "' + sendHidden + '"');
         var _lastValues = _renderEngine.getValues(sendHidden === true);

         // Add lang
         _lastValues[KEY_LANG] = _lang;
      
         console.log('[fe$engine] Capturing url parameters');
         var params = fe$utils.listUrlParameters();
         for (var k in params) {
            _lastValues[PREFIX_CAPTUREDREQPARAMS + k] = params[k];
         }
         _lastValues['referrerURL'] = document.referrer;
         
         return _dconversorEngine.convert(_lastValues)
      } else {
         console.log('[fe$engine] Errors found: ' + JSON.stringify(errors));

      }
      if (_validationCallback) {
         _validationCallback(fe$utils.isDictEmpty(errors), errors);
      }
      return null;
   }
   _instance.isValid = function () {
      _renderEngine.clearAllInvalid();
      var errors = _renderEngine.areValid();
      if (errors == null) {
         errors = {};
      }
      // Check all global validations
      var globalSuccess = true;
      if ('validIf' in _def) {
         console.log('[fe$ngine] GValidation: Executing global validations');
         for (var i = 0; i < _def.validIf.length; i++) {
            var ast = _def.validIf[i].ast;
            console.log('[fe$ngine] GValidation: Executing global validation: ' + JSON.stringify(ast));
            var result = FE$XInterpreter.evaluate(ast, _idSolver, _fexiExecutor.getFunctionSolver());

            console.log('[fe$ngine] GValidation: Evaluation of (' + _def.validIf[i].condition + ') evaluated as: ' + result);
            if (result == false) {
               errors['global'] = translate(_def.validIf[i].message, _lang);

               for (var j = 0; j < _def.validIf[i].highlight.length; j++) {
                  var name = _def.validIf[i].highlight[j].name;
                  var message = _def.validIf[i].highlight[j].message;
                  _renderEngine.toggleInvalid(name, true, translate(message, _lang));
               }
            }
         }
      }

      if (_validationCallback) {
         _validationCallback(fe$utils.isDictEmpty(errors), errors);
      }
      console.log('[fe$ngine] Errors: ', errors);
      return errors;
   }

   _instance.lock = function (doLock) {
      this._isLocked = doLock;
      if (doLock) {
         fe$utils.addClass('locked', _root);
      } else {
         fe$utils.removeClass('locked', _root)
      }
      _renderEngine.lock(doLock);
   }


   return _instance;
})();
/* --------------------- DEFINITION OF VALIDATOR -------------------- */
function FE$Validator() { }
FE$Validator.prototype = new Object();
FE$Validator.prototype.nature = function () { return 'validator'; }
FE$Validator.prototype._initialize = function (valueProvider) { }
FE$Validator.prototype.getType = function () {
   throw new FEngineException('No type set for validator');
}
FE$Validator.prototype.getForControl = function () {
   throw new FEngineException('No forControl set for validator');
}
FE$Validator.prototype.getForVariant = function () {
   throw new FEngineException('No forVariant set for validator');
}
FE$Validator.prototype.validate = function (value, configuration, translationSvc) {
   throw new FEngineException('validate not defined in validator');
}
FE$Validator.prototype.initialize = function () {
   // Empty initialization by default
}

/* --- BASE Validator --- */
function FE$BaseValidator() {
   this._def = null;
   this._vProvider = null;
}
FE$BaseValidator.prototype = new FE$Validator();
FE$BaseValidator.prototype._initialize = function (valueProvider) {
   console.log('[FE$BaseValidator] Initialized')
   this._vProvider = valueProvider;
   this.initialize();
}

FE$BaseValidator.prototype.getForControl = function () {
   return 'any';
}
FE$BaseValidator.prototype.getForVariant = function () {
   return 'raw';
}

FE$BaseValidator.prototype.getValueProvider = function () {
   return this._vProvider;
}



/* --------------------- DEFINITION OF RENDERER ------------------ */
function FE$Renderer() { }
FE$Renderer.prototype = new Object();
FE$Renderer.prototype.nature = function () { return 'renderer'; }
FE$Renderer.prototype.lock = function (doLock) { } // Empty by default
FE$Renderer.prototype.render = function (where, lang) {
   throw new FEngineException('Render not defined on renderer');
}

FE$Renderer.prototype.isValid = function () {
   throw new FEngineException('getValue not defined on renderer');
}
FE$Renderer.prototype.getValue = function () {
   throw new FEngineException('getValue not defined on renderer');
}
FE$Renderer.prototype._getValue = function () {
   throw new FEngineException('getValue not defined on renderer');
}
FE$Renderer.prototype.getElement = function () {
   throw new FEngineException('getElement not defined on renderer');
}
FE$Renderer.prototype.getType = function () {
   throw new FEngineException('getType not defined on renderer');
}
FE$Renderer.prototype.getVariant = function () {
   return 'raw';
}
FE$Renderer.prototype._render = function () {
   throw new FEngineException('innerRender not defined on renderer. Did you forget to extend FE$BaseRenderer?');
}
FE$Renderer.prototype.render = function () {
   throw new FEngineException('render not defined on renderer');
}
FE$Renderer.prototype._translateTo = function (lang) {
   throw new FEngineException('_translateTo not defined on renderer');
}
FE$Renderer.prototype.translateTo = function (lang) {
   // A renderer can decide not supporting i18n
}
FE$Renderer.prototype.isValueControl = function () {
   // By default all renderers are value containers. But can be overriden for controls like images or labels
   return true;
}

FE$Renderer.prototype.isFileControl = function () {
   // By default all renderers are value containers. But can be overriden for controls like images or labels
   return false;
}

FE$Renderer.prototype.setProxy = function (p) {
   this._proxy = p;
}
FE$Renderer.prototype.getProxy = function (p) {
   return this._proxy;
}
FE$Renderer.prototype.onEvent = function (event, control) { }


function FE$BaseRenderer() {
   this._wrapper = null;
   this._container = null;
   this._def = null;
   this._errorLbl = null;
   this._lang = null;
   this._isVisible = true;
}

FE$BaseRenderer.prototype = new FE$Renderer();

FE$BaseRenderer.prototype.onEvent = function (event, data, control) {
   console.log('[fe$BR] Detected event ' + event + ' on ' + control);
}
FE$BaseRenderer.prototype._translateTo = function (lang) {
   while (this._errorLbl.hasChildNodes()) {
      this._errorLbl.removeChild(this._errorLbl.firstChild);
   }
   fe$utils.removeClass('error', this._container);
   this._lang = lang;
   this.translateTo(lang)
}

FE$BaseRenderer.prototype.getLanguage = function () {
   return this._lang;
}

FE$BaseRenderer.prototype.isVisible = function () {
   return this._isVisible;
}
FE$BaseRenderer.prototype.setVisible = function (visible, freeSpace) {
   this._isVisible = visible;
   if (freeSpace) { // Should be null when visible but IE does not allow removing property this way
      this._container.parentNode.style.display = visible ? 'inline-block' : 'none';
   } else {
      this._container.style.visibility = visible ? 'visible' : 'hidden';
   }
}

FE$BaseRenderer.prototype.getDefaultLanguage = function () {
   return this._proxy.defaultLang;
}
FE$BaseRenderer.prototype.notifyChange = function () {
   this._proxy.onEvent(this.getProxy().Events.CHANGE, this._def.name);
}
FE$BaseRenderer.prototype.subscribeToChangesOn = function (who) {
   this._proxy.subscribeTo(this.getProxy().Events.CHANGE, who, this._def.name);
}

FE$BaseRenderer.prototype.getValueOf = function (who) {
   return this._proxy.getValueOf(who);
}

FE$BaseRenderer.prototype.getDefinition = function () {
   return this._def;
}
FE$BaseRenderer.prototype.getElement = function () {
   return this._container;
}
FE$BaseRenderer.prototype.getTranslator = function () {
   return this._proxy.translate;
}

FE$BaseRenderer.prototype.forceWidth = function (w) {
   this._wrapper.style.width = w;
}
FE$BaseRenderer.prototype.getDataProvider = function () {
   if (!this._proxy) {
      throw new FEngineException("No data provider available");
   }
   return this._proxy.queryData;
}
FE$BaseRenderer.prototype._getValue = function () {
   console.log('[FE$BaseRenderer] Checking if valid');
   if (this.isValid() == null) { // Returns error message if not valid
      return this.getValue();
   }
   return null;
}

FE$BaseRenderer.prototype.isValid = function () {
   // console.log('[FE$BaseRenderer] Trying validators: ' + JSON.stringify(this._def.validators));

   var error = this._proxy.validate(this.getValue(), this.getType(), this.getVariant(), this._def.validators, this._lang);
   console.log('[FE$BaseRenderer] Validation of ' + this._def.name + ' returned ' + error);
   this.toggleInvalid(error != null, error);
   return error;
}

FE$BaseRenderer.prototype.toggleInvalid = function (invalid, message) {
   fe$utils.removeClass('error', this._wrapper)
   while (this._errorLbl.hasChildNodes()) {
      this._errorLbl.removeChild(this._errorLbl.firstChild);
   }

   console.log('[FE$BaseRenderer] Toggling invalid? ' + invalid + ' for control ' + this._def.name);
   if (invalid) {

      this._errorLbl.appendChild(document.createTextNode(message));
      fe$utils.addClass('error', this._wrapper)
   }
}

FE$BaseRenderer.prototype.getValue = function () {
   // Make sure that validation is in place
   return this._def;
}

FE$BaseRenderer.prototype.setValue = function (v) {
   console.warn('[FER] ERROR: Not implemented setValue on ' + this._def.type + '. Attempted setting value ' + v);
}

FE$BaseRenderer.prototype._render = function (def, where, lang) {
   console.log('[FER] Called inner render with definition: ' + JSON.stringify(def));
   this._def = def
   this._lang = lang;
   this._wrapper = document.createElement('div');
   this._wrapper.setAttribute('class', 'FE-wrapperR '
      + (this.isValueControl() ? ' FE-valueWrapperR' : '')
      + ' FE-' + this.getType() + 'WrapperR'
      + ' FE-' + this.getType() + this.getVariant() + 'WrapperR'
      + (def.cssClass ? ' ' + def.cssClass : '')
   )
   this._container = document.createElement('div');
   this._container.setAttribute('class', 'FE-controlR'
      + ' FE-' + this.getType()
      + ' FE-' + this.getType() + '-' + this.getVariant()
   )
   this._wrapper.appendChild(this._container);
   /* this._langSvc = translationSvc;
   this._validationSvc = validationSvc;
   this._dataProviderSvc = dataProviderSvc; */
   this._errorLbl = document.createElement('label');
   this._errorLbl.setAttribute('class', 'FE-controlR-error FE-' + this.getType() + '-error');

   if (def.width) {
      // this._box.style.width = def.width;
      this.forceWidth(def.width);
   }

   where.appendChild(this._wrapper);
   this.render(this._container, lang)
   this._container.appendChild(this._errorLbl);
}

/* --------------------- DEFINITION OF DATA CONVERTER ------------------ */
function FE$DataConverter() {
}
FE$DataConverter.prototype = new Object();
FE$DataConverter.prototype.nature = function () { return 'dataconverter'; }
FE$DataConverter.prototype.getType = function () {
   throw new FEngineException('No type set for converter');
}

FE$DataConverter.prototype.convert = function (values, configuration) {
   throw new FEngineException('convert not defined in converter');
}



/* -------------------- ABSTRACTION OF OPTIONS AND DATASOURCES ------------- */
function FE$OptionHelper(def, proxy, selfFilter, sort) {
   this._definition = def;
   this._proxy = proxy;
   this._selfFilter = selfFilter; // Used when the current control is also used for filtering in datasource but not with the default value (like in autocomplete)
   this._sort = !(sort === false);

   this._isFull = true;

   this._optionsForLang = []; // Sorted options (local or server)
   this._lastDSOptions = []; // Unsorted server options
   this._disabledOptions = {};

   if (def.options && typeof def.options == 'object') {
      if (!def.options.length && !def.options.datasource) { // Array
         throw new FEngineException('No way to understand options ' + JSON.stringify(def.options));
      }
   }
}

FE$OptionHelper.prototype = new Object();

FE$OptionHelper.prototype.getOptionValueForIndex = function (index) {
   return this._optionsForLang[index].value;

}
FE$OptionHelper.prototype.getOptionIndexForValue = function (value) {
   for (var i = 0; i < this._optionsForLang.length; i++) {
      if (this._optionsForLang[i].value == value) {
         return i;
      }
   }
   return null;

}
FE$OptionHelper.prototype.getOptionTextForValue = function (value, lang) {
   for (var i = 0; i < this._optionsForLang.length; i++) {
      if (this._optionsForLang[i].value == value) {
         if (this._optionsForLang[i][lang]) {
            return this._optionsForLang[i][lang];
         } else {
            return this._optionsForLang[i].label;
         }

      }
   }
   return null;
}


FE$OptionHelper.prototype._usesDataSource = function () {
   var uses = (this._definition.options && typeof this._definition.options == 'object' && this._definition.options.datasource);
   console.log('[feSC] Using datasource? ' + uses);
   return uses;
}
FE$OptionHelper.prototype._onDSOptions = function (callback, lang, resp) {
   console.log('[feOH] Obtained datasource options: ' + JSON.stringify(resp) + ' for language ' + lang);
   this._lastDSOptions = resp.data.records;
   this._isFull = resp.data.full;
   callback(this._getTranslationTo(this._lastDSOptions, lang), this._isFull)

}

FE$OptionHelper.prototype._recalculateEnabled = function (options) {
   // Calculate enabled
   console.log('[feOH] Recalculating enabled');
   for (var i = 0; i < options.length; i++) {
      var option = this._definition.options[i];
      if ('enableAST' in option) { // Check if this option has to be enabled and set in the option and in the global disabled dictionary
         var enabled = this._proxy.fexExecuteAST(option.enableAST);
         if (enabled !== true) {
            this._disabledOptions[option.value] = true;
         } else {
            delete this._disabledOptions[option.value];
         }
      }
   }
}
FE$OptionHelper.prototype.getOptions = function (lang, callback) {
   // Invokes callback once it has the options available
   if (this._usesDataSource()) {
      var params = {}
      if (this._definition.options.inputs) {
         for (var i = 0; i < this._definition.options.inputs.length; i++) {
            var key = this._definition.options.inputs[i];
            var value = this._proxy.getValueOf(key);
            if (value != null && typeof value == 'object' && '' in value) {
               console.log('Obtaining simple value from complex one');
               value = value[''];
            }

            params[key] = value;

         }
      }
      // Add language
      params.lang = lang;
      if (this._selfFilter) {
         params[this._definition.name] = this._selfFilter();
      }
      console.log('[feOH] Querying data for datasource ', this._definition.options);
      
      if(this._definition.options.datasource.indexOf(',')>-1){
         var multiDataSource = this._definition.options.datasource.split(',');
         multiDataSource.forEach(ds => {
            this._proxy.queryData(params,
               ds, this._definition.name,
               this._onDSOptions.bind(this, callback, lang),
               this._definition.options.url // Just in case it is defined
            );   
         }
         );
      }else{
         this._proxy.queryData(params,
            this._definition.options.datasource, this._definition.name,
            this._onDSOptions.bind(this, callback, lang),
            this._definition.options.url // Just in case it is defined
            );
         }
   } else {
      this._isFull = true;

      this._recalculateEnabled(this._definition.options);

      // Do filtering here
      var opts = this._getTranslationTo(this._definition.options, lang);
      var filtered = [];
      var filter = null;
      if (this._selfFilter) {
         filter = this._selfFilter().toUpperCase();
      }
      console.log('[feOH] Filter for option helper is ' + filter + ' using ' + this._selfFilter + ' on ' + JSON.stringify(opts));
      for (var i = 0; i < opts.length; i++) {
         console.log('[feOH] Checking ' + JSON.stringify(opts[i]))
         if (!filter || opts[i].label.toUpperCase().indexOf(filter) != -1) {
            filtered.push(opts[i]);

         } else {
            console.log('[feOH] Filter not passed using filter ' + filter + ' on ' + opts[i].label)
         }

      }
      console.log('[feOH] Options from option helper are: ' + JSON.stringify(filtered));
      console.log('[feOH] Disabled options: ' + JSON.stringify(this._disabledOptions));
      callback(filtered, this._isFull);
   }
}

FE$OptionHelper.prototype.getTranslationTo = function (lang) {
   if (this._usesDataSource()) {
      return this._getTranslationTo(this._lastDSOptions, lang);
   } else {
      return this._getTranslationTo(this._definition.options, lang);
   }
}
FE$OptionHelper.prototype._getTranslationTo = function (options, lang) {
   // Returns the options but in the new language or default one
   console.log('[feOH] Getting translation to ' + lang);
   this._optionsForLang = []
   for (var i = 0; i < options.length; i++) {
      var item = {}
      this._optionsForLang.push(item);
      var anyLang = null;
      for (var k in options[i]) {
         if (k == 'value') {
            item[k] = options[i][k];
            // Apply last known state (for enabled)
            item.enabled = (this._disabledOptions[item.value] !== true);
            console.log('[feOH] Enabled ' + item.enabled + ' for item with value ' + item.value);
         } else if (k == 'label' || k == 'description') { // Single label
            item[k] = this._proxy.translate(options[i][k], lang);
         } else { // Language?
            item[k] = options[i][k];
            anyLang = k;
            if (k == lang) {
               item.label = options[i][k];
            } else if (!item.label && k == this._proxy.defaultLang) {
               item.label = options[i][k];
            }
         }

      }
      if (!item.label && anyLang) { // If no default lang nor current lang defined..use any other one
         item.label = item[anyLang]
      }
      // console.log('[feOH] Added item: ' + JSON.stringify(item) + ' from ' + JSON.stringify(options[i]) + ' using lang ' + lang)
   }
   if (this._sort) {
      console.log('[feOH] SORTING Options');
      this._optionsForLang.sort(function (a, b) {
         console.log('[feOH] Sorting label a: "' + JSON.stringify(a) + '" and b: "' + JSON.stringify(b) + '"')
         var al = a.label.toUpperCase();
         var bl = b.label.toUpperCase();
         if (al < bl) {
            return -1;
         } else if (al > bl) {
            return 1;
         }
         return 0;
      });
   } else {
      console.log('[feOH] NOT sorting Options');
   }

   return this._optionsForLang;
}

FE$OptionHelper.prototype.getDependencies = function () {
   // Returns the controls that this control depends on according to the datasource (if used)

   var ret = [];
   if (this._usesDataSource()) {
      if (this._definition.options.inputs) {
         // Datasource has dependencies
         for (var i = 0; i < this._definition.options.inputs.length; i++) {
            ret.push(this._definition.options.inputs[i]);
         }
      }
   } else { // Check if any option has a enabledIf attribute
      console.log('[feOH] Checking options for non datasource');
      for (var i = 0; i < this._definition.options.length; i++) {
         if ('enabledIf' in this._definition.options[i]) {
            console.log('[feOH] Detected an enabledIf option');
            var ast = this._proxy.fexParseAST(this._definition.options[i].enabledIf);
            var ids = this._proxy.fexGetASTIdentifiers(ast);
            this._definition.options[i].enableAST = ast;
            for (var j = 0; j < ids.length; j++) {
               ret.push(ids[j]);
            }
         }
      }
   }
   return ret;
}

export { FE$BaseValidator, fe$utils, FE$DataConverter, FE$BaseRenderer, FEngineException, FE$OptionHelper }